import React, { useEffect, useState }from 'react';
import logo from './logo.svg';

import exampleTxt from './longnecks.txt'

import cantoeTxt from './cantoes.txt'

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { stringify } from 'querystring';

import Button from '@mui/material/Button';
import { TextField } from '@mui/material';




type attribute = {
  trait_type: string,
  value: string
};

type longNeck = {
  id: number,
  name: string,
  image: string,
  attributes: attribute[],
  rarity: number,
}



// type valueMap = {value: string: number[]};

type valueMap = Map<string, number>;


function CantopunkTable() {


  useEffect(()=> {
    // getText()
  }, [])






const [page, setPage] = useState<number>(0);



function cantopunks() {
  const base = "https://cantopunks.xyz/theyHere/";

  let cantoesURLS = [];
  for (let i = 0; i < 10000; i++) {
    cantoesURLS.push(base + i.toString() + ".png")
  }

  const getCantopunks = (cantoesURLS: string[], page: number) => {
    let pageStart = page*10;
    let pageEnd = pageStart + 10;
    return cantoesURLS.slice(pageStart, pageEnd).map((URL, index) => (
      <TableRow
        key={index+0}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell component="th" scope="row">
          {0 + pageStart+ index}
        </TableCell>
        <TableCell align="right">{<img src={URL} width={80} height={80}></img>}</TableCell>
      </TableRow>
    ))
  }
  return (

    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
           <TableCell align="right">image</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {getCantopunks(cantoesURLS, page)}
        </TableBody>
      </Table>
    </TableContainer>
  );
}


  const totalPages = 999;


  return (
    <Box>
      <Box style={{
        display: 'flex',
      }}>
            <Button variant="outlined" onClick={() => setPage((page + 1) % (totalPages + 1)) }>Forward</Button>
            <p>{page + 1}</p>
            <Button variant="outlined" onClick={() => setPage(page === 0 ? totalPages : page - 1) }>Back</Button>
            <TextField
        label="Text Input"
        onChange= {(event) => setPage(parseInt(event.target.value))}
    />
    </Box>
        {cantopunks()}
    </Box>
  );
}

export default CantopunkTable;
